import { render, staticRenderFns } from "./SavePinConfirmBtn.vue?vue&type=template&id=0a4a285c&lang=pug"
import script from "./SavePinConfirmBtn.vue?vue&type=script&lang=js"
export * from "./SavePinConfirmBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports